import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { label: "Why It Matters", href: "/#problem" },
  { label: "Who We Help", href: "/#who" },
  { label: "Learn", href: "/#learn" },
  { label: "Contact", href: "/#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-cream/80 backdrop-blur-xl border-b border-linen" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" aria-label="AIWC home"><Logo /></Link>
        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <a key={l.label} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
               className="link-underline text-sm font-medium text-stone-600 hover:text-ink transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="/#join" data-testid="nav-join-button"
             className="hidden sm:inline-flex items-center rounded-full bg-ink text-cream text-sm font-semibold px-6 py-3 hover:bg-ember transition-colors duration-300">
            Join the community
          </a>
          <button className="lg:hidden p-2 text-ink" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="nav-menu-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }}
                      className="lg:hidden overflow-hidden bg-cream border-b border-linen" data-testid="nav-mobile-menu">
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a key={l.label} href={l.href} onClick={() => setOpen(false)}
                   className="font-serif text-2xl text-ink">{l.label}</a>
              ))}
              <a href="/#join" onClick={() => setOpen(false)} data-testid="nav-join-button-mobile"
                 className="inline-flex w-fit items-center rounded-full bg-ember text-cream text-sm font-semibold px-6 py-3">
                Join the community
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
